import React from 'react';

const Navigation = ({ currentPage, onNavigate }) => {
  const navItems = [
    { id: 'home', label: 'హోమ్', icon: '🏠', kicker: 'ప్రారంభం' },
    { id: 'charitra', label: 'చరిత్ర', icon: '📜', kicker: 'వారసత్వం' },
    { id: 'media', label: 'కీర్తనలు', icon: '🎼', kicker: 'సంగీతం' },
  ];

  return (
    <nav className="app-navigation">
      {/* Mobile Bottom Nav */}
      <div className="mobile-bottom-nav">
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`nav-btn ${currentPage === item.id ? 'active' : ''}`}
            onClick={() => onNavigate(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </div>

      {/* Desktop Top Nav (links only, logic in Layout/Header) */}
      <div className="desktop-nav-links">
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`desktop-nav-item ${currentPage === item.id ? 'active' : ''}`}
            onClick={() => onNavigate(item.id)}
          >
            <span className="item-kicker">{item.kicker}</span>
            <span className="item-label">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
